import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import tourism from "../images/Header/TourismLogo.png";
import home from "../images/Header/home.png";
import about from "../images/Header/about.png";
import gallery from "../images/Header/gallery.png";
import contact from "../images/Header/contact.png";
import "./Header.css";


const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = (path) => {
    navigate(path);
    setOpen(false);
  };

  const handleContactClick = () => {
    // navigate("/");
    setTimeout(() => {
      document
        .getElementById("footer")
        ?.scrollIntoView({ behavior: "smooth" });
    }, 200);
    setOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
        
          {/* MOBILE HAMBURGER */}
          <div className="hamburger-circle" onClick={() => setOpen(true)}>
            ☰
          </div>

          {/* LOGO */}
          <div className="logoCon">
          <div className="logo" onClick={() => navigate("/")}>
  <img src="/Flamingo.jpeg" alt="Logo" />
</div>
        <div className="tourismCon">
        <div className="tourismLogo">
        <img src={tourism} alt="Tourism Logo" /> 
        </div>
        <div className="tourism">
        <h4>Registered under <br/> Sikkim Tourism & Civil Aviation</h4>
        <h2>1510/DoT&CAv/E/22/TA</h2>
        </div>
        </div>
      </div>
          {/* DESKTOP NAV */}
          <nav className="nav">
            <ul>
              <li
                className={location.pathname === "/" ? "active" : ""}
                onClick={() => handleNavigate("/")}
              >
                Home
              </li>

              <li
                className={location.pathname === "/about" ? "active" : ""}
                onClick={() => handleNavigate("/about")}
              >
                About Us
              </li>

              <li
                className={location.pathname === "/gallery" ? "active" : ""}
                onClick={() => handleNavigate("/gallery")}
              >
                Photo Gallery
              </li>

              <li onClick={handleContactClick}>
                Contact Us
              </li>
            </ul>
          </nav>
        </div>
        
      </header>

        
      {/* SIDEBAR */}
      <div className={`sidebar ${open ? "open" : ""}`}>

        {/* TOP */}
        <div className="sidebar-top">
          <img src="/Flamingo.jpeg" alt="Logo" className="sidebar-logo" />
          <h2>FLAMINGO</h2>
        </div>

        {/* MENU */}
        <ul className="sidebar-menu">
          <li onClick={() => handleNavigate("/")}><img src={home} alt="Home Icon"/> Home</li>
          <li onClick={() => handleNavigate("/about")}><img src={about} alt="About Us Icon"/> About Us</li>
          <li onClick={() => handleNavigate("/gallery")}><img src={gallery} alt="Gallery Icon"/> Photo Gallery</li>
          <li onClick={handleContactClick}><img src={contact} alt="Contact Us Icon"/> Contact Us</li>
        </ul>

        {/* BOTTOM */}
        <div className="sidebar-bottom">
          <img src={tourism} alt="Tourism Logo" /> 
          <p>Registered under</p>
          <p><b>Sikkim Tourism & Civil Aviation</b></p>
          <p>1510/DoT&CAV/E/22/TA</p>
        </div>
      </div>

      {/* OVERLAY */}
      {open && (
        <div className="headeroverlay" onClick={() => setOpen(false)}></div>
      )}
      <div className="shadow"></div>
    </>
  );
};

export default Header;